export function getFileSizeFromBase64(base64String) {
  // 1. Remove the data URL prefix (e.g., 'data:image/png;base64,')
  // The split takes the part after the comma.
  const base64WithoutPrefix = base64String.split(",")[1];

  if (!base64WithoutPrefix) {
    console.error("Invalid Base64 string format.");
    return 0;
  }

  // 2. Decode the Base64 string into a binary string.
  // btoa and atob are used for Base64 encoding/decoding.
  // atob decodes the Base64 string into a string where each character represents a byte.
  const binaryString = atob(base64WithoutPrefix);

  // 3. The length of the binary string is the size in bytes.
  const sizeInBytes = binaryString.length;

  return sizeInBytes;
}
